module.exports = __webpack_public_path__ + "img/electron.93a3e359.svg";